<template>
  <pl-dialog
    size="relative"
    :title="'Export Engagment Data'"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div class="px-6 pb-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div @click="handleSaveToGoogleDrive" class="bg-white hover:bg-gray-50 pt-8 pl-8 pr-8 py-7 rounded cursor-pointer border border-solid border-gray-200 hover:border-primary" >
          <div class="flex items-center">
            <img id="icon-g-drive" class="h-6 w-6" alt="Google Drive" src="/static/summary_icons/I_GoogleDrive.png" />
            <h5 class="text-base antialiased font-semibold ml-3">
              Google Drive
            </h5>
            <div v-if="uploading_to_drive === true" class="loader"></div>
          </div>
          <div class="mt-3">
            <p class="text-sm text-gray-600 font-medium">
              Save Data to your Google Drive.
            </p>
          </div>
        </div>
        <div @click="handleDownloadFile" class="bg-white hover:bg-gray-50 px-8 py-7 rounded border border-solid border-gray-200 hover:border-primary cursor-pointer" >
          <div class="flex items-center">
            <img
              id="icon-g-drive"
              class="h-7 w-7"
              alt="DownloadLocal"
              src="/static/summary_icons/I_DownloadFile.png"
            />
            <h5 class="text-base antialiased font-semibold ml-2">
              Download CSV File
            </h5>
          </div>
          <div class="mt-3">
            <p class="text-sm text-gray-600 font-medium">
              Save data to your local files.
            </p>
          </div>
        </div>
        <div
          @click="openSyncAssessmentModal()"
          class="bg-white hover:bg-gray-50 px-7 py-7 rounded border border-solid border-gray-200 hover:border-primary cursor-pointer"
        >
          <div class="flex items-center">
            <i class="fa-solid fa-link text-xl"></i>
            <h5 class="text-base antialiased font-semibold ml-2">
              Sync to LMS
            </h5>
          </div>
          <div class="mt-3">
            <p class="text-sm text-gray-600 font-medium">
              Sync Data to your LMS gradebook.
            </p>
          </div>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import Vue from 'vue';
  import { EventBus } from 'utils/event-bus';
  import googleDrive from 'utils/googleDrive';
  import { mapGetters } from 'vuex';
  // Download File Locally
  import downloadFile from 'utils/downloadFile';

  export default Vue.extend({
    data() {
      return {
        saving_to_drive: false,
        show_saved_message: false,
        uploading_to_drive: false,
      };
    },
    computed: {
      ...mapGetters([
        'getProfile',
        'getCourseDetail',
        'getCurrentRT',
        'getCurrentDiscussion',
      ]),
      is_current_course_whith_students_to_get_file: function () {
        if (this.$route.params.roundtableID) {
          if (this.getCurrentRT.submissions.length > 1) {
            return true;
          }
          return false;
        }
        if (this.$route.params.liveDiscussionID) {
          if (this.getCurrentDiscussion.participations.length) {
            return true;
          }
          return false;
        }
      },
    },
    methods: {
      handleSaveToGoogleDrive: async function() {
        if (!this.getProfile.is_paid) {
          const text =
            'student data export feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        if (this.is_current_course_whith_students_to_get_file === true) {
          this.saving_to_drive = true;
          this.uploading_to_drive = true;
          return this.getFile().then((data) => {
            return googleDrive
              .uploadCSVFileToDrive(data, this.fileName)
              .then(() => {
                const toast = {
                  type: 'Success',
                  message:
                    'File Created! It was placed in the "Parlay Data" folder in your Google Drive.',
                  time: 5000,
                };
                EventBus.$emit('createToast', toast);
                this.saving_to_drive = false;
                this.$emit('close');
                this.uploading_to_drive = false;
              })
              .catch((err) => {
                this.saving_to_drive = false;
                this.uploading_to_drive = false;
                alert('Error uploading the file to Drive. Please try again', err);
              });
          });
        }
        const toast = {
          type: 'Warning',
          message: "Sorry! You don't have data to save in Google Drive...",
          time: 5000,
        };
        return EventBus.$emit('createToast', toast);
      },
      handleDownloadFile() {
        if (!this.getProfile.is_paid) {
          const text =
            'student data export feature for both types of RoundTables.';
          EventBus.$emit('open-upgrade-modal', text);
          return;
        }
        // Download Locally
        if (this.is_current_course_whith_students_to_get_file === true) {
          this.getFile().then((data) => {
            downloadFile(data, this.fileName);
          });
          return;
        }
        const toast = {
          type: 'Warning',
          message: "Sorry! You don't have data to download...",
          time: 5000,
        };
        EventBus.$emit('createToast', toast);
      },
      openSyncAssessmentModal: function () {
        EventBus.$emit('openAssessmentModal');
      },
    },
    props: {
      getFile: {
        type: Function,
        default() {
          return function () {
            return '';
          };
        },
      },
      fileName: {
        type: String,
        default: '',
      },
      showButtons: {
        type: Boolean,
        default: false,
      },
    },
  });
</script>

<style lang="stylus" scoped>
  .modal-button
    box-shadow: -2px 2px 8px 0px rgba(0,0,0,0.2)
    height: 120px
    width: 180px
</style>
<style scoped>
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-left: 12px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgb(255, 255, 255);
    border-right: 3px solid rgb(255, 255, 255);
    border-bottom: 3px solid rgba(255, 255, 255);
    border-left: 3px solid #72CCD7;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// exportEngagementDataModal.vue?275ffb98